import React from 'react';

export default function HUD({ progress = 0 }) {
  const pct = Math.round(progress * 1000) / 10;
  return (
    <div className="hud-corners">
      {/* Animated grid background */}
      <div className="absolute inset-0 tech-grid opacity-30" />

      {/* Top-left frame */}
      <div className="absolute left-4 md:left-8 top-24 md:top-28">
        <div className="relative w-40 h-10">
          <span className="corner-bracket tl" />
          <span className="corner-bracket bl" />
          <div className="mono text-[10px] tracking-[0.3em] text-cyan-300/70 pl-3 pt-2">TRK_FEED // ACTIVE</div>
        </div>
      </div>

      {/* Bottom-left telemetry */}
      <div className="absolute left-4 md:left-8 bottom-6 md:bottom-8">
        <div className="relative glass rounded-md px-3 py-2 mono text-[10px] tracking-[0.25em] text-cyan-200/80">
          <div className="flex items-center gap-4">
            <span>LAT 51.54N</span>
            <span>LON 0.10W</span>
            <span className="text-cyan-400">NODE LDN-22</span>
          </div>
        </div>
      </div>

      {/* Bottom-right progress */}
      <div className="absolute right-4 md:right-8 bottom-6 md:bottom-8">
        <div className="relative glass rounded-md px-3 py-2 mono text-[10px] tracking-[0.25em] text-cyan-200/80 flex items-center gap-3">
          <span>CAM_TRK</span>
          <div className="w-28 h-[3px] bg-cyan-900/50 overflow-hidden rounded">
            <div
              className="h-full bg-gradient-to-r from-cyan-400 to-sky-300"
              style={{ width: `${pct}%`, transition: 'width 0.15s linear' }}
            />
          </div>
          <span className="text-cyan-300">{pct.toFixed(1)}%</span>
        </div>
      </div>
    </div>
  );
}
